var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.681 21.7708L20.6476 20.5333L20.7123 20.5183L17.1328 16.2344C15.9308 14.8053 14.7354 13.3707 13.5467 11.9306C13.5467 11.9089 17.2506 1.66558 17.2721 1.6306C17.2937 1.59563 19.7983 5.99609 23.3878 12.222L29.525 22.9184L29.5714 23H6.77416L13.681 21.7741V21.7708ZM0 20.4683C0 20.4683 1.69022 17.5152 3.75697 13.9209L7.51228 7.38185L11.8896 3.69426C14.2964 1.66558 16.2719 0 16.2819 0C16.2656 0.0621527 16.2416 0.122021 16.2105 0.178217L11.4567 10.4149L6.78909 20.4683H3.39537C1.52933 20.4683 0.00165871 20.4683 0.00165871 20.4683H0Z",
    fill: "#0089D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureIcon);
export default __webpack_public_path__ + "static/media/azure-icon.9ed5d0f543438a863ab579e154cfbafb.svg";
export { ForwardRef as ReactComponent };